/**
 * Filebase Service - IPFS pinning via the server-side API
 *
 * The browser holds NO Filebase credentials. After a file is in Vercel Blob,
 * pinBlob() asks /api/pin-ipfs to stream it to Filebase and re-verify the
 * SHA-256, then returns the IPFS CID and gateway URLs.
 */

import { pinToIpfs } from './uploadClient';

class FilebaseService {
  /**
   * Pin an already-uploaded blob to IPFS.
   *
   * @param {Object} params
   * @param {string} params.blobUrl - Vercel Blob URL of the uploaded bytes
   * @param {string} params.sha256 - Hex SHA-256 of those exact bytes
   * @param {string} params.fileName - Name to record with the IPFS object
   * @param {string} [params.description]
   * @param {string} [params.caseNumber]
   * @returns {Promise<Object>} { cid, gatewayUrl, filebaseUrl, ipfsHash, ... }
   */
  async pinBlob({ blobUrl, sha256, fileName, description, caseNumber }) {
    console.log('[FilebaseService] Pinning blob to IPFS', { fileName });
    const result = await pinToIpfs({ blobUrl, sha256, fileName, description, caseNumber });

    return {
      success: true,
      cid: result.cid,
      ipfsCid: result.ipfsCid || result.cid,
      ipfsHash: result.ipfsHash,
      fileName: result.fileName,
      fileSize: result.size,
      url: result.gatewayUrl,
      gatewayUrl: result.gatewayUrl,
      filebaseUrl: result.filebaseUrl
    };
  }

  /**
   * Get IPFS gateway URL for a CID
   *
   * @param {string} cid - IPFS CID
   * @returns {string} Gateway URL
   */
  getGatewayUrl(cid) {
    return `https://ipfs.filebase.io/ipfs/${cid}`;
  }
}

// Export singleton instance
const filebaseService = new FilebaseService();

export default filebaseService;
export { FilebaseService };
